/*!
 * @bilibili/vanilla-toast v1.1.4
 * Released under the ISC License.
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = global || self, global.toast = factory());
}(this, function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    var ToastType;
    (function (ToastType) {
        ToastType["info"] = "info";
        ToastType["success"] = "success";
        ToastType["warn"] = "warn";
        ToastType["error"] = "error";
    })(ToastType || (ToastType = {}));
    var TYPE_STYLE = {
        info: {
            backgroundColor: "rgba(0, 0, 0, .8)"
        },
        success: {
            backgroundColor: "rgba(57, 175, 100, 1)"
        },
        error: {
            backgroundColor: "rgba(228, 12, 12, 1)"
        },
        warn: {
            backgroundColor: "rgba(255, 134, 39, 1)"
        }
    };
    var keyframesName = "vanilla-toast-slide";
    (function appendKeyframes() {
        if (document.querySelector("." + keyframesName)) {
            return;
        }
        var keyframes = "{\n    0% {\n      transform: translate(-50%, 0);\n      -webkit-transform: translate(-50%, 0);\n      opacity: 0;\n    }\n    100% {\n      transform: translate(-50%, -50%);\n      -webkit-transform: translate(-50%, -50%);\n      opacity: 1;\n    }\n  }";
        var runkeyframes = "\n    @keyframes " + keyframesName + " " + keyframes + "\n    @-webkit-keyframes " + keyframesName + " " + keyframes + "\n  ";
        var style = document.createElement("style");
        style.type = "text/css";
        style.className = keyframesName;
        style.innerHTML = runkeyframes;
        var head = document.querySelector("head");
        if (!head) {
            console.warn("head tag does not exist!");
            return;
        }
        head.appendChild(style);
    })();
    var toast = function (msg, options) {
        var defaultOptions = {
            duration: 2000,
            onClose: function () { }
        };
        var _a = options || defaultOptions, _b = _a.duration, duration = _b === void 0 ? 2000 : _b, customStyle = _a.customStyle, _c = _a.onClose, onClose = _c === void 0 ? function () { } : _c;
        var msgStyle = __assign({ position: "fixed", left: "50%", top: "50%", boxSizing: "border-box", width: "auto", padding: "6px 12px", borderRadius: "8px", maxWidth: "80%", background: "rgba(0, 0, 0, .7)", fontSize: "14px", color: "#fff", lineHeight: "1.4", wordWrap: "break-word", textAlign: "justify", zIndex: "99999", cursor: "default", userSelect: "none", animation: ".3s ease-int-out both", animationName: keyframesName, webkitAnimation: ".3s ease-int-out both", webkitAnimationName: keyframesName }, customStyle);
        var node = document.createElement("div");
        Object.assign(node.style, msgStyle);
        node.innerText = msg;
        document.body.appendChild(node);
        setTimeout(function () {
            typeof onClose === "function" && onClose();
            document.body.removeChild(node);
        }, duration);
    };
    var typeToast = {};
    Object.keys(ToastType).forEach(function (item) {
        typeToast[item] = function (msg, options) {
            var _options = options || {};
            toast(msg, __assign(__assign({}, _options), { customStyle: __assign(__assign({}, TYPE_STYLE[item]), (_options.customStyle || {})) }));
        };
    });

    return typeToast;

}));
